import React from 'react';
import { css } from '@emotion/core';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';

import ButtonWithLoadingEffect from 'Mui/ButtonWithLoadingEffect';
import { stylePropType } from 'utils/propTypes';

function ActionButton({ text, onClick, btnStyle = '', disabled, isLoading }) {
    return (
        <ButtonWithLoadingEffect
            css={[buttonStyle, css(btnStyle)]}
            variant="contained"
            disabled={disabled}
            onClick={onClick}
            isLoading={isLoading}
        >
            <Typography variant="subtitle1" css={textStyle}>
                {text}
            </Typography>
        </ButtonWithLoadingEffect>
    );
}

ActionButton.propTypes = {
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    onClick: PropTypes.func,
    btnStyle: stylePropType,
    disabled: PropTypes.bool,
    isLoading: PropTypes.bool
};

export default ActionButton;

const buttonStyle = css`
    padding: 10px 16px;
    width: 100%;
    height: 48px;
    border-radius: 28px;
`;

const textStyle = css`
    display: flex;
    align-items: center;
    color: inherit;
`;
